<template>
    <div>
        <Loading :value="loading" ></Loading>
        <v-card color="blue-grey darken-1"
                class="white--text elevation-5">
            <v-layout>
                <v-flex xs4 pt-2 pl-2>
                    <v-avatar
                            size="100px"
                            color="grey lighten-4"
                    >
                        <!--<img src="/static/avatar-conducteur.png" alt="avatar">-->
                        <img :src="employe.urlAvatar" alt="avatar">
                    </v-avatar>
                </v-flex>
                <v-flex xs8>
                    <v-card-title primary-title>
                        <div>
                            <div class="subheading">{{employe.nomPrenom.substr(0,25)}} </div>
                            <div class="body-1">{{employe.poste.substr(0,25)}}</div>
                            <div class="caption" >
                                <v-chip color="green" text-color="white">{{employe.typeContrat.substr(0,25)}}</v-chip>
                            </div>
                        </div>
                    </v-card-title>
                </v-flex>
            </v-layout>
            <v-divider light></v-divider>
            <v-card-actions class="pa-3">
                <v-tooltip bottom>
                <v-icon
                        v-if="employe.absent == true"
                        slot="activator"
                        large
                        color="white"
                >
                    exit_to_app
                </v-icon>
                    absent
                </v-tooltip>


                <v-badge color="red" v-if="employe.contratValide == false">
                    <template v-slot:badge>
                        <span>!</span>
                    </template>
                    <v-tooltip bottom>
                    <v-icon
                            slot="activator"
                            large
                            color="white"
                    >
                        mail
                    </v-icon>
                        contrat non conforme
                    </v-tooltip>
                </v-badge>


                <v-spacer></v-spacer>
                <v-btn @click="showDetailEmpl(employe.idEmploye)" small color="info">
                    Suivre
                    <v-icon right dark>navigate_next</v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>

</template>

<script>
    import Loading from '@/components/Loading';
    export default {
        components: {Loading},
        name: "modelCarteEmploye",
        props: {
            employe: {
                type: Object
            }
        },
        data(){
            return {
                notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
                droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
                loading: false,



            }
        },
        methods:{

            showDetailEmpl(idEmp){
                this.$emit("detailEmpl",idEmp);
                this.$emit("close");
            },

            successNotif(mess = ""){
                this.$notify({
                    title: 'ENREGISTREMENT REUSSI',
                    message: mess,
                    type: 'success',
                    position: 'top-center'
                })
            },


        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/resourceHumaine/modelCarteEmploye.vue